module.exports = __webpack_public_path__ + "img/FONBET.BY.8d649139.svg";